import React from 'react'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface ChoiceSelectItemProps {
    id: number
    name: string
    value: any
    isSingle?: boolean
    isSelected: boolean
    handleClick: (option: any) => void
    formatLabel?: () => string
}

const ChoiceSelectItem: React.FC<ChoiceSelectItemProps> = ({
    id,
    name,
    value,
    isSingle,
    isSelected,
    handleClick,
    formatLabel
}) => {
    let uiElClassname = `border w-5 h-5 mt-0.5 flex justify-center items-center text-xs`

    uiElClassname += isSingle ? ' rounded-full' : ' rounded'

    if (isSelected) {
        uiElClassname += isSingle ? ' border-[--tb-green]' : ' bg-[--tb-green] border-[--tb-green]'
    } else {
        uiElClassname += ' border-gray-400 group-hover:bg-[--tb-blushPrimary]'
    }

    return (
        <label
            htmlFor={`${id}`}
            className='flex gap-x-3 my-0 items-start cursor-pointer group'
            aria-label={`Selecteer ${name}`}
        >
            {isSingle ? (
                <input
                    type='radio'
                    name={`${name}`}
                    id={`${id}`}
                    className='hidden'
                    onChange={() => handleClick(value)}
                />
            ) : (
                <input
                    type='checkbox'
                    name={`${name}`}
                    id={`${id}`}
                    className='hidden'
                    onChange={() => handleClick(value)}
                />
            )}
            <div className={uiElClassname}>
                {isSelected && (
                    <DynamicFaIcon
                        iconName={isSingle ? 'circle' : 'check'}
                        iconPrefix={'fas'}
                        className={isSingle ? 'text-[--tb-green]' : 'text-white'}
                        aria-label={isSingle ? 'Selecteer deze optie' : 'Selecteer deze optie'}
                    />
                )}
            </div>
            <span aria-label={name}>{formatLabel ? formatLabel() : name}</span>
        </label>
    )
}

export default ChoiceSelectItem
